/** Per-file attachment upload limit (must match backend MAX_FILE_SIZE_BYTES). */
export const MAX_ATTACHMENT_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const MAX_ATTACHMENT_FILE_SIZE_LABEL = '50 MB';
